<script>
import Slider from "@vueform/slider";
import api from "@/axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { clothsData } from "./data-products";
import Loader from "../components/loader";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Produtos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Slider, Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      clothsData: clothsData,
      title: "Produtos",
      items: [
        {
          text: "Comercial",
          href: "/",
        },
        {
          text: "Produtos",
          active: true,
        },
      ],
      sliderPrice: 800,
      currentPage: 1,
      discountRates: [],
    };
  },
  mounted() {
    this.totalRows = this.items.length;
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
  methods: {
    valuechange(value) {
      this.clothsData = clothsData.filter(function (product) {
        return product.newprice <= value;
      });
    },

    searchFilter(e) {
      const searchStr = e.target.value;
      this.clothsData = clothsData.filter((product) => {
        return (
            product.name.toLowerCase().search(searchStr.toLowerCase()) !== -1
        );
      });
    },

    discountLessFilter(e, percentage) {
      if (e === "accepted" && this.discountRates.length === 0) {
        this.clothsData = clothsData.filter((product) => {
          return product.discount < percentage;
        });
      } else {
        this.clothsData = clothsData.filter((product) => {
          return product.discount >= Math.max.apply(null, this);
        }, this.discountRates);
      }
    },

    discountMoreFilter(e, percentage) {
      if (e === "accepted") {
        this.discountRates.push(percentage);
      } else {
        this.discountRates.splice(this.discountRates.indexOf(percentage), 1);
      }
      this.clothsData = clothsData.filter((product) => {
        return product.discount >= Math.max.apply(null, this);
      }, this.discountRates);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Filtrar</h4>

            <div>
              <h5 class="font-size-14 mb-3">Categorias</h5>
              <ul class="list-unstyled product-list">
                <li>
                  <a href="javascript: void(0);">
                    <i class="mdi mdi-chevron-right me-1"></i> Categoria Testes 001
                  </a>
                </li>
                <li>
                  <a href="javascript: void(0);">
                    <i class="mdi mdi-chevron-right me-1"></i> Categoria Testes 099
                  </a>
                </li>
                <li>
                  <a href="javascript: void(0);">
                    <i class="mdi mdi-chevron-right me-1"></i> Categoria Testes 055
                  </a>
                </li>
                <li>
                  <a href="javascript: void(0);">
                    <i class="mdi mdi-chevron-right me-1"></i> Categoria Testes 002
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-4 pt-3">
              <h5 class="font-size-14 mb-3">Valor</h5>
              <Slider
                  v-model="sliderPrice"
                  :min="0"
                  :max="1000"
                  @change="valuechange"
              />
            </div>

            <div class="mt-4 pt-3">
              <h5 class="font-size-14 mb-3">Desconto</h5>

              <b-form-checkbox
                  id="productdiscountCheck1"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountLessFilter($event, 10)"
              >Menor que 10%</b-form-checkbox
              >

              <b-form-checkbox
                  id="productdiscountCheck2"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountMoreFilter($event, 10)"
              >Acima de 10%</b-form-checkbox
              >

              <b-form-checkbox
                  id="productdiscountCheck3"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountMoreFilter($event, 20)"
              >Acima de 20%</b-form-checkbox
              >

              <b-form-checkbox
                  id="productdiscountCheck4"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountMoreFilter($event, 30)"
              >Acima de 30%</b-form-checkbox
              >

              <b-form-checkbox
                  id="productdiscountCheck5"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountMoreFilter($event, 40)"
              >Acima de 40%</b-form-checkbox
              >

              <b-form-checkbox
                  id="productdiscountCheck6"

                  value="accepted"
                  unchecked-value="not_accepted"
                  @change="discountMoreFilter($event, 50)"
              >Acima de 50%</b-form-checkbox
              >
            </div>

            <div class="mt-4 pt-3">
              <h5 class="font-size-14 mb-3">Avaliação de Clientes</h5>
              <div>
                <b-form-checkbox
                    id="checkbox-1"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                >
                  4
                  <i class="bx bx-star text-warning"></i> ou mais
                </b-form-checkbox>

                <b-form-checkbox
                    id="checkbox-2"

                    name="checkbox-2"
                    value="accepted"
                    unchecked-value="not_accepted"
                >
                  3
                  <i class="bx bx-star text-warning"></i> ou mais
                </b-form-checkbox>

                <b-form-checkbox
                    id="checkbox-3"

                    name="checkbox-3"
                    value="accepted"
                    unchecked-value="not_accepted"
                >
                  2
                  <i class="bx bx-star text-warning"></i> ou mais
                </b-form-checkbox>
                <b-form-checkbox
                    id="checkbox-4"

                    name="checkbox-4"
                    value="accepted"
                    unchecked-value="not_accepted"
                >
                  1
                  <i class="bx bx-star text-warning"></i>
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="row mb-3">
          <div class="col-xl-4 col-sm-6">
            <div class="mt-2">
              <h5>Destaque</h5>
            </div>
          </div>
          <div class="col-lg-8 col-sm-6">
            <form class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
              <div class="search-box me-2">
                <div class="position-relative">
                  <input
                      id="inputPesquisa"
                      type="text"
                      class="form-control border-0"
                      placeholder="Pesquisar..."
                      @input="searchFilter($event)"
                  />
                  <i class="bx bx-search-alt search-icon"></i>
                </div>
              </div>
              <ul class="nav nav-pills product-view-nav">
                <li class="nav-item">
                  <a class="nav-link active" href="javascript: void(0);">
                    <i class="bx bx-grid-alt"></i>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="javascript: void(0);">
                    <i class="bx bx-list-ul"></i>
                  </a>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div class="row">
          <div
              v-for="data in clothsData"
              :key="data.id"
              class="col-xl-4 col-sm-6"
          >
            <div class="card">
              <div class="card-body">
                <div class="product-img position-relative">
                  <div v-if="data.discount" class="avatar-sm product-ribbon">
                    <span class="avatar-title rounded-circle bg-primary"
                    >-{{ data.discount }}%</span
                    >
                  </div>
                  <router-link
                      :to="`/loja/produto-detalhe/${data.id}`"
                  >
                    <img
                        :src="`${data.product}`"
                        alt
                        class="img-fluid mx-auto d-block"
                    />
                  </router-link>
                </div>
                <div class="mt-4 text-center">
                  <h5 class="mb-3 text-truncate">
                    <router-link
                        class="text-dark"
                        :to="`/loja/produto-detalhe/${data.id}`"
                    >{{ data.name }}</router-link
                    >
                  </h5>
                  <p class="text-muted">
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star text-warning"></i>
                    <i class="bx bxs-star"></i>
                  </p>
                  <h5 class="my-0">
                    <span class="text-muted me-2">
                      <del>R$ {{ data.oldprice }}</del>
                    </span>
                    <b>R$ {{ data.newprice }}</b>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12">
            <b-pagination
                v-if="clothsData.length > 0"
                class="justify-content-center"
                pills
                v-model="currentPage"
                :total-rows="clothsData.length"
                :per-page="6"
                aria-controls="my-table"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
